import React from 'react';
import type { FieldRenderProps } from 'react-final-form';
import type { InputFieldV2Props } from '../../InputFieldV2/InputFieldV2';
import DatePickerInput, { DatePickerInputProps } from '../DatePickerInput/DatePickerInput';

export interface DatePickerInputAdapterProps
  extends FieldRenderProps<string, HTMLElement>,
    Pick<InputFieldV2Props, 'isRequired' | 'label' | 'placeholder' | 'id'>,
    DatePickerInputProps {}

const DatePickerInputAdapter = ({
  formatDate,
  parseDate,
  isRequired,
  label,
  placeholder = 'MM/DD/YYYY',
  input,
  meta,
  id,
  ...rest
}: DatePickerInputAdapterProps): React.ReactElement => {
  const errorMessage = meta && meta.touched && meta.error ? meta.error : '';
  const newInputProps = { ...input, errorMessage, placeholder, isRequired, label, id };
  return (
    <DatePickerInput
      inputFieldProps={newInputProps}
      value={input?.value}
      formatDate={formatDate}
      parseDate={parseDate}
      isFormField
      {...rest}
    />
  );
};

export default DatePickerInputAdapter;
